import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { AuthService } from '../auth/auth.service';
import { Subject, Observer, Observable } from 'rxjs/Rx';
import { environment } from 'environments/environment';



@Injectable({
  providedIn: 'root'
})
export class JsondatahandlerService {

  connected: boolean = false;
  fromConnectionCheck: boolean = false;

  observLogin: Observable<JSON>;
  private loginData: Subject<JSON>;

  observTerminalOverview: Observable<JSON>;
  private terminalOverviewData: Subject<JSON>;

  observTerminalData: Observable<JSON>;
  private terminalData: Subject<JSON>;

  observProductData: Observable<JSON>;
  private productData: Subject<JSON>;

  observDLCData: Observable<JSON>;
  private dlcData: Subject<JSON>;

  observTerminalConfigData: Observable<JSON>;
  private terminalConfigData: Subject<JSON>;

  observTerminalPciData: Observable<JSON>;
  private terminalPciData: Subject<JSON>;

  observTerminalConfigRights: Observable<JSON>;
  private terminalConfigRights: Subject<JSON>;

  observTerminalUpdate: Observable<JSON>;
  private terminalUpdate: Subject<JSON>;

  observHsUpdate: Observable<JSON>;
  private hsUpdate: Subject<JSON>;

  observPciUpdate: Observable<JSON>;
  private pciUpdate: Subject<JSON>;

  observRightsUpdate: Observable<JSON>;
  private rightsUpdate: Subject<JSON>;

  observHsDelete: Observable<JSON>;
  private hsDelete: Subject<JSON>;

  observPciDelete: Observable<JSON>;
  private pciDelete: Subject<JSON>;

  observMediaThumb: Observable<JSON>;
  private mediaThumb: Subject<JSON>;

  observProductThumb: Observable<JSON>;
  private productThumb: Subject<JSON>;

  observGalleryThumb: Observable<JSON>;
  private galleryThumb: Subject<JSON>;

  observTerminalDelete: Observable<JSON>;
  private terminalDelete: Subject<JSON>;

  observTerminalAdd: Observable<JSON>;
  private terminalAdd: Subject<JSON>;

  observTerminalPublish: Observable<JSON>;
  private terminalPublish: Subject<JSON>;

  observTerminalPublishRunning: Observable<JSON>;
  private terminalPublishRunning: Subject<JSON>;

  observProductOverviewData: Observable<JSON>;
  private productOverviewData: Subject<JSON>;

  observProductMediaChangeData: Observable<JSON>;
  private productProductMediaChangeData: Subject<JSON>;

  observSaveProduct: Observable<JSON>;
  private saveProduct: Subject<JSON>;

  observNewProduct: Observable<JSON>;
  private newProduct: Subject<JSON>;

  observNewSetup: Observable<JSON>;
  private newSetup: Subject<JSON>;

  observDeleteSetup: Observable<JSON>;
  private deleteSetup: Subject<JSON>;

  observUpdateSetup: Observable<JSON>;
  private updateSetup: Subject<JSON>;

  observNewCat: Observable<JSON>;
  private newCat: Subject<JSON>;

  observDeleteCat: Observable<JSON>;
  private deleteCat: Subject<JSON>;

  observUpdateCat: Observable<JSON>;
  private updateCat: Subject<JSON>;

  observLangChange: Observable<JSON>;
  private langChange: Subject<JSON>;

  observDLCOverviewData: Observable<JSON>;
  private dlcOverviewData: Subject<JSON>;

  observSaveDLCData: Observable<JSON>;
  private saveDLCData: Subject<JSON>;

  observAddDLCData: Observable<JSON>;
  private addDLCData: Subject<JSON>;

  observMediaData: Observable<JSON>;
  private mediaData: Subject<JSON>;

  observMediaChange: Observable<JSON>;
  private mediaChange: Subject<JSON>;

  observMediaUploadData: Observable<JSON>;
  private mediaUploadData: Subject<JSON>;

  observMediaUpload: Observable<JSON>;
  private mediaUpload: Subject<JSON>;

  observUserList: Observable<JSON>;
  private userList: Subject<JSON>;

  observUserData: Observable<JSON>;
  private userData: Subject<JSON>;

  observPwChange: Observable<JSON>;
  private pwChange: Subject<JSON>;

  observUserDataChange: Observable<JSON>;
  private userDataChange: Subject<JSON>;

  observAccountingData: Observable<JSON>;
  private accountingData: Subject<JSON>;

  observSlotData: Observable<JSON>;
  private slotData: Subject<JSON>;

  observSettingsData: Observable<JSON>;
  private settingsData: Subject<JSON>;

  observColorData: Observable<JSON>;
  private colorData: Subject<JSON>;

  observSetColorData: Observable<JSON>;
  private setColorData: Subject<JSON>;

  observLangData: Observable<JSON>;
  private langData: Subject<JSON>;

  observUiData: Observable<JSON>;
  private uiData: Subject<JSON>;

  observFontData: Observable<JSON>;
  private fontData: Subject<JSON>;

  observItemData: Observable<JSON>;
  private itemData: Subject<JSON>;

  observRenderData: Observable<JSON>;
  private renderData: Subject<JSON>;

  observEnvData: Observable<JSON>;
  private envData: Subject<JSON>;

  observRelogData: Observable<JSON>;
  private relogData: Subject<JSON>;

  observOrderChangeData: Observable<JSON>;
  private orderChangeData: Subject<JSON>;

  observHsOrderChangeData: Observable<JSON>;
  private hsOrderChangeData: Subject<JSON>;

  observBackendFilterData: Observable<JSON>;
  private backendFilterData: Subject<JSON>;

  observBackendFilterChanged: Observable<JSON>;
  private backendFilterChanged: Subject<JSON>;

  observFrontendFilterData: Observable<JSON>;
  private frontendFilterData: Subject<JSON>;

  observFrontendFilterChanged: Observable<JSON>;
  private frontendFilterChanged: Subject<JSON>;

  observUserGroupData: Observable<JSON>;
  private userGroupData: Subject<JSON>;

  observUserGroupChanged: Observable<JSON>;
  private userGroupChanged: Subject<JSON>;

  observVaitemGroupData: Observable<JSON>;
  private vaitemGroupData: Subject<JSON>;

  observVaitemGroupChanged: Observable<JSON>;
  private vaitemGroupChanged: Subject<JSON>;

  observPrepareDownload: Observable<JSON>;
  private prepareDownload: Subject<JSON>;

  observUserProfileChanged: Observable<JSON>;
  private userProfileChanged: Subject<JSON>;

  observImage360Data: Observable<JSON>;
  private image360Data: Subject<JSON>;

  observVideo360Data: Observable<JSON>;
  private video360Data: Subject<JSON>;

  observConnectionCheck: Observable<JSON>;
  private conncetionCheck: Subject<JSON>;

  observB2CRegistration: Observable<JSON>;
  private b2CRegistration: Subject<JSON>;

  observB2CLogin: Observable<JSON>;
  private b2CLogin: Subject<JSON>;

  observB2CResetPw: Observable<JSON>;
  private b2CResetPw: Subject<JSON>;

  observCloudConnected: Observable<JSON>;
  private cloudConnected: Subject<JSON>;

  observDoubleOptin: Observable<JSON>;
  private doubleOptin: Subject<JSON>;

  observConsumerProfileChange: Observable<JSON>;
  private consumerProfile: Subject<JSON>;

  observCreateGWCode: Observable<JSON>;
  private createGWCode: Subject<JSON>;

  observGWCodeData: Observable<JSON>;
  private gwCodeData: Subject<JSON>;

  observGWCodeChange: Observable<JSON>;
  private gwCodeChange: Subject<JSON>;

  observAGBData: Observable<JSON>;
  private agbData: Subject<JSON>;

  observB2CChange: Observable<JSON>;
  private b2CChange: Subject<JSON>;

  observlngTxtData: Observable<JSON>;
  private lngTxtData: Subject<JSON>;

  constructor(private auth: AuthService) {
    this.terminalOverviewData = new Subject<JSON>();
    this.observTerminalOverview = this.terminalOverviewData.asObservable();

    this.loginData = new Subject<JSON>();
    this.observLogin = this.loginData.asObservable();

    this.terminalData = new Subject<JSON>();
    this.observTerminalData = this.terminalData.asObservable();

    this.terminalConfigData = new Subject<JSON>();
    this.observTerminalConfigData = this.terminalConfigData.asObservable();

    this.terminalPciData = new Subject<JSON>();
    this.observTerminalPciData = this.terminalPciData.asObservable();

    this.terminalConfigRights = new Subject<JSON>();
    this.observTerminalConfigRights = this.terminalConfigRights.asObservable();

    this.terminalUpdate = new Subject<JSON>();
    this.observTerminalUpdate = this.terminalUpdate.asObservable();

    this.hsUpdate = new Subject<JSON>();
    this.observHsUpdate = this.hsUpdate.asObservable();

    this.pciUpdate = new Subject<JSON>();
    this.observPciUpdate = this.pciUpdate.asObservable();

    this.rightsUpdate = new Subject<JSON>();
    this.observRightsUpdate = this.rightsUpdate.asObservable();

    this.hsDelete = new Subject<JSON>();
    this.observHsDelete = this.hsDelete.asObservable();

    this.pciDelete = new Subject<JSON>();
    this.observPciDelete = this.pciDelete.asObservable();

    this.mediaThumb = new Subject<JSON>();
    this.observMediaThumb = this.mediaThumb.asObservable();

    this.productThumb = new Subject<JSON>();
    this.observProductThumb = this.productThumb.asObservable();

    this.galleryThumb = new Subject<JSON>();
    this.observGalleryThumb = this.galleryThumb.asObservable();

    this.terminalDelete = new Subject<JSON>();
    this.observTerminalDelete = this.terminalDelete.asObservable();

    this.terminalAdd = new Subject<JSON>();
    this.observTerminalAdd = this.terminalAdd.asObservable();

    this.terminalPublish = new Subject<JSON>();
    this.observTerminalPublish = this.terminalPublish.asObservable();

    this.terminalPublishRunning = new Subject<JSON>();
    this.observTerminalPublishRunning = this.terminalPublishRunning.asObservable();

    this.productData = new Subject<JSON>();
    this.observProductData = this.productData.asObservable();

    this.dlcData = new Subject<JSON>();
    this.observDLCData = this.dlcData.asObservable();

    this.productOverviewData = new Subject<JSON>();
    this.observProductOverviewData = this.productOverviewData.asObservable();

    this.productProductMediaChangeData = new Subject<JSON>();
    this.observProductMediaChangeData = this.productProductMediaChangeData.asObservable();

    this.saveProduct = new Subject<JSON>();
    this.observSaveProduct = this.saveProduct.asObservable();

    this.newProduct = new Subject<JSON>();
    this.observNewProduct = this.newProduct.asObservable();

    this.newSetup = new Subject<JSON>();
    this.observNewSetup = this.newSetup.asObservable();

    this.deleteSetup = new Subject<JSON>();
    this.observDeleteSetup = this.deleteSetup.asObservable();

    this.updateSetup = new Subject<JSON>();
    this.observUpdateSetup = this.updateSetup.asObservable();

    this.newCat = new Subject<JSON>();
    this.observNewCat = this.newCat.asObservable();

    this.deleteCat = new Subject<JSON>();
    this.observDeleteCat = this.deleteCat.asObservable();

    this.updateCat = new Subject<JSON>();
    this.observUpdateCat = this.updateCat.asObservable();

    this.langChange = new Subject<JSON>();
    this.observLangChange = this.langChange.asObservable();

    this.dlcOverviewData = new Subject<JSON>();
    this.observDLCOverviewData = this.dlcOverviewData.asObservable();

    this.saveDLCData = new Subject<JSON>();
    this.observSaveDLCData = this.saveDLCData.asObservable();

    this.addDLCData = new Subject<JSON>();
    this.observAddDLCData = this.addDLCData.asObservable();

    this.mediaData = new Subject<JSON>();
    this.observMediaData = this.mediaData.asObservable();

    this.mediaChange = new Subject<JSON>();
    this.observMediaChange = this.mediaChange.asObservable();

    this.mediaUploadData = new Subject<JSON>();
    this.observMediaUploadData = this.mediaUploadData.asObservable();

    this.mediaUpload = new Subject<JSON>();
    this.observMediaUpload = this.mediaUpload.asObservable();

    this.userList = new Subject<JSON>();
    this.observUserList = this.userList.asObservable();

    this.userData = new Subject<JSON>();
    this.observUserData = this.userData.asObservable();

    this.pwChange = new Subject<JSON>();
    this.observPwChange = this.pwChange.asObservable();

    this.userDataChange = new Subject<JSON>();
    this.observUserDataChange = this.userDataChange.asObservable();

    this.slotData = new Subject<JSON>();
    this.observSlotData = this.slotData.asObservable();

    this.settingsData = new Subject<JSON>();
    this.observSettingsData = this.settingsData.asObservable();

    this.accountingData = new Subject<JSON>();
    this.observAccountingData = this.accountingData.asObservable();

    this.colorData = new Subject<JSON>();
    this.observColorData = this.colorData.asObservable();

    this.setColorData = new Subject<JSON>();
    this.observSetColorData = this.setColorData.asObservable();

    this.langData = new Subject<JSON>();
    this.observLangData = this.langData.asObservable();

    this.itemData = new Subject<JSON>();
    this.observItemData = this.itemData.asObservable();

    this.fontData = new Subject<JSON>();
    this.observFontData = this.fontData.asObservable();

    this.uiData = new Subject<JSON>();
    this.observUiData = this.uiData.asObservable();

    this.envData = new Subject<JSON>();
    this.observEnvData = this.envData.asObservable();

    this.renderData = new Subject<JSON>();
    this.observRenderData = this.renderData.asObservable();

    this.relogData = new Subject<JSON>();
    this.observRelogData = this.relogData.asObservable();

    this.orderChangeData = new Subject<JSON>();
    this.observOrderChangeData = this.orderChangeData.asObservable();

    this.hsOrderChangeData = new Subject<JSON>();
    this.observHsOrderChangeData = this.hsOrderChangeData.asObservable();

    this.backendFilterData = new Subject<JSON>();
    this.observBackendFilterData = this.backendFilterData.asObservable();

    this.backendFilterChanged = new Subject<JSON>();
    this.observBackendFilterChanged = this.backendFilterChanged.asObservable();

    this.frontendFilterData = new Subject<JSON>();
    this.observFrontendFilterData = this.frontendFilterData.asObservable();

    this.frontendFilterChanged = new Subject<JSON>();
    this.observFrontendFilterChanged = this.frontendFilterChanged.asObservable();

    this.userGroupData = new Subject<JSON>();
    this.observUserGroupData = this.userGroupData.asObservable();

    this.userGroupChanged = new Subject<JSON>();
    this.observUserGroupChanged = this.userGroupChanged.asObservable();

    this.vaitemGroupData = new Subject<JSON>();
    this.observVaitemGroupData = this.vaitemGroupData.asObservable();

    this.vaitemGroupChanged = new Subject<JSON>();
    this.observVaitemGroupChanged = this.vaitemGroupChanged.asObservable();

    this.prepareDownload = new Subject<JSON>();
    this.observPrepareDownload = this.prepareDownload.asObservable();

    this.userProfileChanged = new Subject<JSON>();
    this.observUserProfileChanged = this.userProfileChanged.asObservable();

    this.image360Data = new Subject<JSON>();
    this.observImage360Data = this.image360Data.asObservable();

    this.video360Data = new Subject<JSON>();
    this.observVideo360Data = this.video360Data.asObservable();

    this.conncetionCheck = new Subject<JSON>();
    this.observConnectionCheck = this.conncetionCheck.asObservable();

    this.b2CRegistration = new Subject<JSON>();
    this.observB2CRegistration = this.b2CRegistration.asObservable();

    this.b2CLogin = new Subject<JSON>();
    this.observB2CLogin = this.b2CLogin.asObservable();

    this.b2CResetPw = new Subject<JSON>();
    this.observB2CResetPw = this.b2CResetPw.asObservable();

    this.cloudConnected = new Subject<JSON>();
    this.observCloudConnected = this.cloudConnected.asObservable();

    this.doubleOptin = new Subject<JSON>();
    this.observDoubleOptin = this.doubleOptin.asObservable();

    this.consumerProfile = new Subject<JSON>();
    this.observConsumerProfileChange = this.consumerProfile.asObservable();

    this.createGWCode = new Subject<JSON>();
    this.observCreateGWCode = this.createGWCode.asObservable();

    this.gwCodeData = new Subject<JSON>();
    this.observGWCodeData = this.gwCodeData.asObservable();

    this.gwCodeChange = new Subject<JSON>();
    this.observGWCodeChange = this.gwCodeChange.asObservable();

    this.agbData = new Subject<JSON>();
    this.observAGBData = this.agbData.asObservable();

    this.b2CChange = new Subject<JSON>();
    this.observB2CChange = this.b2CChange.asObservable();

    this.lngTxtData = new Subject<JSON>();
    this.observlngTxtData = this.lngTxtData.asObservable();

  }

  public ProcessSocketData(data: Object) {
    var jsonObj: JSON = JSON.parse(data.toString());

    if (jsonObj['call'] != 'ping' && !environment.production) {
      console.log(jsonObj);
    }

    if (jsonObj['call'] == 'angularlogin') {
      this.loginData.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'cloud_connect') {
      if (!this.fromConnectionCheck) {
        this.connected = true;
        this.cloudConnected.next(jsonObj);
      } else if (this.fromConnectionCheck) {
        this.conncetionCheck.next(jsonObj);
      }
    }

    if (jsonObj['success'] && jsonObj['call'] == 'relogin') {
      this.auth.loggedIn = true;
      this.auth.tryRelog = false;
      this.relogData.next(jsonObj);
    }

    if (!jsonObj['success'] && jsonObj['call'] == 'relogin') {
      this.auth.tryRelog = false;
      //this.auth.logout();
    }

    if (jsonObj['call'] == 'terminallist') {
      this.terminalOverviewData.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'terminal_data') {
      this.terminalData.next(jsonObj);
    }

    if ((jsonObj['success'] && jsonObj['call'] == 'terminal_config_data') || (jsonObj['success'] && jsonObj['call'] == 'create_hs') || (jsonObj['success'] && jsonObj['call'] == 'create_hs')) {
      this.terminalConfigData.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'terminal_config_set') {
      this.hsUpdate.next(jsonObj);
    }

    if ((jsonObj['success'] && jsonObj['call'] == 'terminal_pci_data') || (jsonObj['success'] && jsonObj['call'] == 'create_pci')) {
      this.terminalPciData.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'terminal_config_rights') {
      this.terminalConfigRights.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'terminal_edit_set') {
      this.terminalUpdate.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'terminal_pci_set') {
      this.pciUpdate.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'terminal_right_set') {
      this.rightsUpdate.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'delete_hs') {
      this.hsDelete.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'delete_pci') {
      this.pciDelete.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'terminal_data_get_thumb') {
      this.mediaThumb.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'product_data_get_thumb') {
      this.productThumb.next(jsonObj);
    }

    if ((jsonObj['success'] && jsonObj['call'] == 'gallery_media') || jsonObj['success'] && jsonObj['call'] == 'gallery_media_by_filter') {
      this.galleryThumb.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'deleteterminal') {
      this.terminalDelete.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'newterminal') {
      this.terminalAdd.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'publishterminal') {
      this.terminalPublish.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'terminallistpublish') {
      this.terminalPublishRunning.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'productlist') {
      this.productOverviewData.next(jsonObj);
    }

    if ((jsonObj['success'] && jsonObj['call'] == 'product_data')) {
      this.productData.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'product_file_gallery_change') {
      this.productProductMediaChangeData.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'product_edit_set') {
      this.saveProduct.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'product_new') {
      this.newProduct.next(jsonObj);
    }

    if ((jsonObj['success'] && jsonObj['call'] == 'create_setup')) {
      this.newSetup.next(jsonObj);
    }

    if ((jsonObj['call'] == 'delete_setup')) {
      this.deleteSetup.next(jsonObj);
    }

    if ((jsonObj['success'] && jsonObj['call'] == 'edit_setup')) {
      this.updateSetup.next(jsonObj);
    }

    if ((jsonObj['success'] && jsonObj['call'] == 'create_cat')) {
      this.newCat.next(jsonObj);
    }

    if ((jsonObj['call'] == 'delete_cat')) {
      this.deleteCat.next(jsonObj);
    }

    if ((jsonObj['success'] && jsonObj['call'] == 'edit_cat')) {
      this.updateCat.next(jsonObj);
    }

    if ((jsonObj['success'] && jsonObj['call'] == 'change_lang')) {
      this.langChange.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'dlclist') {
      this.dlcOverviewData.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'dlc_data') {
      this.dlcData.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'bundle_edit_set') {
      this.saveDLCData.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'new_bundle_added') {
      this.addDLCData.next(jsonObj);
    }

    if (jsonObj['call'] == 'media_meta') {
      this.mediaData.next(jsonObj);
    }

    if (jsonObj['call'] == 'media_meta_edit_set') {
      this.mediaChange.next(jsonObj);
    }

    if (jsonObj['call'] == 'upload_media') {
      this.mediaUploadData.next(jsonObj);
    }

    if (jsonObj['call'] == 'mediagallery_upload') {
      this.mediaUpload.next(jsonObj);
    }

    if (jsonObj['call'] == 'profile_list') {
      this.userList.next(jsonObj);
    }

    if (jsonObj['call'] == 'profile_data') {
      this.userData.next(jsonObj);
    }

    if (jsonObj['call'] == 'change_password') {
      this.pwChange.next(jsonObj);
    }

    if (jsonObj['call'] == 'profile_edit_set') {
      this.userDataChange.next(jsonObj);
    }

    if (jsonObj['call'] == 'showaccounting') {
      this.accountingData.next(jsonObj);
    }

    if (jsonObj['call'] == 'new_slots') {
      this.slotData.next(jsonObj);
    }

    if (jsonObj['call'] == 'get_config') {
      this.settingsData.next(jsonObj);
    }

    if (jsonObj['call'] == 'get_colors') {
      this.colorData.next(jsonObj);
    }


    if (jsonObj['call'] == 'set_color') {
      this.setColorData.next(jsonObj);
    }

    if (jsonObj['call'] == 'get_languages') {
      this.langData.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'itemlist') {
      this.itemData.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'uilist') {
      this.uiData.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'fontlist') {
      this.fontData.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'renderlist') {
      this.renderData.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'envlist') {
      this.envData.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'ChangeOrder') {
      this.orderChangeData.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'HsChangeOrder') {
      this.hsOrderChangeData.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'get_backendfilter_tags') {
      this.backendFilterData.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'BackendFilterChanged') {
      this.backendFilterChanged.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'get_frontendfilter_tags') {
      this.frontendFilterData.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'FrontendFilterChanged') {
      this.frontendFilterChanged.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'get_user_group') {
      this.userGroupData.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'ChangedUserGroup') {
      this.userGroupChanged.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'ChangedVaitemGroup') {
      this.vaitemGroupChanged.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'get_variation_groups') {
      this.vaitemGroupData.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'prepare_download') {
      this.prepareDownload.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'ChangedUserProfile') {
      this.userProfileChanged.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'image360') {
      this.image360Data.next(jsonObj);
    }

    if (jsonObj['success'] && jsonObj['call'] == 'video360') {
      this.video360Data.next(jsonObj);
    }

    if (jsonObj['call'] == 'user_register') {
      this.b2CRegistration.next(jsonObj);
    }

    if (jsonObj['call'] == 'user_b2c_login') {
      this.b2CLogin.next(jsonObj);
    }

    if (jsonObj['call'] == 'reset_b2c_password_get_link') {
      this.b2CResetPw.next(jsonObj);
    }

    if (jsonObj['call'] == 'approve_opt_in') {
      this.doubleOptin.next(jsonObj);
    }

    if (jsonObj['call'] == 'change_b2c_profile') {
      this.consumerProfile.next(jsonObj);
    }

    if (jsonObj['call'] == 'set_gw_code') {
      this.createGWCode.next(jsonObj);
    }

    if (jsonObj['call'] == 'get_gw_code_list') {
      this.gwCodeData.next(jsonObj);
    }

    if (jsonObj['call'] == 'gw_code_change') {
      this.gwCodeChange.next(jsonObj);
    }

    if (jsonObj['call'] == 'get_agb') {
      this.agbData.next(jsonObj);
    }

    if (jsonObj['call'] == 'change_b2c_contact') {
      this.b2CChange.next(jsonObj);
    }

    if (jsonObj['call'] == 'GetCharForFontFile') {
      this.lngTxtData.next(jsonObj);
    }

  }

}
